<script>
    import { onMount } from 'svelte';
    import PortfolioItem from "./item/PortfolioItem.svelte";
    import { projects } from '../../store.js';
    import GLightbox from 'glightbox';
    import { blur } from 'svelte/transition';
    import { quintIn } from 'svelte/easing';
    import lazySizes from 'lazysizes';
    import 'lazysizes/plugins/blur-up/ls.blur-up';
    import 'lazysizes/plugins/parent-fit/ls.parent-fit';
    // polyfills
    import 'lazysizes/plugins/respimg/ls.respimg';
    if (!('object-fit' in document.createElement('a').style)){
        require('lazysizes/plugins/object-fit/ls.object-fit');
    }

    window.lazySizesConfig = window.lazySizesConfig || {};
    lazySizesConfig.expand = 500;
    lazySizesConfig.expFactor = 1.5;
    lazySizesConfig.loadMode = 1;
    lazySizes.cfg.blurupMode = 'auto';

	onMount(() => {
        const lightbox = GLightbox({
            touchNavigation: true,
            loopAtEnd: true,
            slideEffect: 'fade',
            svg:{
                close: `<svg version="1.1"xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                            y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" class="icon">
                            <title>Close</title>
                            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                                <path d="M147,4972C66,4891,0,4820,0,4815c0-6,505-515,1122-1132l1123-1123L1122,1437C505,820,0,310,0,305C0,292,292,0,305,0
                                    c6,0,515,505,1132,1122l1123,1123l1123-1123C4300,505,4810,0,4815,0c13,0,305,292,305,305c0,6-505,515-1122,1132L2875,2560
                                    l1123,1123c617,617,1122,1126,1122,1132c0,13-292,305-305,305c-5,0-515-505-1132-1122L2560,2875L1437,3998
                                    C820,4615,310,5120,305,5120C299,5120,228,5054,147,4972z"/>
                            </g>
                        </svg>`,
                next: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                            <path d="M1277,4992c-70-70-127-131-127-136c0-4,511-521,1135-1149c624-627,1135-1143,1135-1147s-511-520-1135-1147
                                C1661,785,1150,268,1150,263c0-13,253-263,266-263c14,0,2554,2547,2554,2560S1429,5120,1416,5120C1410,5120,1347,5063,1277,4992z"
                                />
                        </g>
                        </svg>`,
                prev: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                            <path d="M2421,3844c-699-701-1271-1279-1271-1284C1150,2547,3691,0,3704,0s266,251,266,264c0,4-511,521-1135,1149
                                c-624,627-1135,1143-1135,1147s511,520,1135,1147c624,628,1135,1145,1135,1150c0,13-253,263-266,263C3697,5120,3120,4546,2421,3844
                                z"/>
                        </g>
                        </svg>`
            },
        });
    });
</script>

<section class="container grid-xl portfolio">
    <div class="columns">
        <div class="column col-12">
            <h2 class="text-center text-uppercase" id="portfolio">Portfolio</h2>
        </div>
        <div class="column col-12" in:blur="{{ duration: 700, easing: quintIn }}">
            <div class="portfolios_container">
                {#each $projects as project}
                    {#if project.id}
                        <PortfolioItem {project} />
                    {/if}
                {/each}
            </div>
        </div>
    </div>
</section>    

<style>  
    .portfolio{
        margin-bottom: 4rem;
    }
    .portfolios_container{
        display: flex;
        flex-flow: row wrap;
        margin: 0 -0.4rem;
    }
    /* @media screen and (max-width: 960px) {
        .gutter_sizer{
            width: 2%;
        }
        .grid_sizer{
            width: 49%;
        }
    }
    @media screen and (max-width: 600px) {
        .grid_sizer{
            width: 0;
        }
        .grid_sizer{
            width: 100%;
        }
    } */
</style>